export const getMediaLink = (fileName: string) => {
  if (fileName) {
    return `https://brickbar.ru/${fileName}`;
  }
  return '';
};
